import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 880,
      width: 880,
    },
    dialogContent: {
      display: 'flex',
      flexFlow: 'column nowrap',
      paddingTop: 0,
    },
    description: {},
    buttonSubmit: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
  }),
  { name: 'TemplateFoundPopup' }
);
